import styled from 'styled-components';

export const LoginLogo = styled.div`
  display: flex;
  align-content: center;
  flex-direction: column;
`;

export const LoginLogoSpan = styled.span`
  margin: 0 -3px;
  font-size: 18px;
  font-weight: 300;  
`;

export const LoginRecovery = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 26px;
  font-size: 16px;
  margin-top: 31px;
  padding-top: 119px;
  margin-bottom: 10vh;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: flex-start;
  border-top: 1px solid #EBEDF2;
  @media(max-width: 1024px) {
    padding-top: 12vh;
  }
  @media(max-width: 426px) {
    font-size: 15px;
  }
`;

export const ResetTitle = styled.span`
  width: 100%;
  margin-bottom: 15px;
  font-size: 1.5em;
  color: #2B323B;
  font-weight: 600;
  line-height: 120%;
  font-style: normal;
  text-align: center;
  letter-spacing: -0.02em;
  font-family: 'Proxima Nova';

`;

export const ResetParagraphs = styled.div`
  color: #38424D;
  font-size: 1em;
  font-weight: 400;
  line-height: 120%;
  text-align: center;
  font-style: normal;
  letter-spacing: -0.35px;
  font-family: 'Proxima Nova';
`;

export const Label = styled.h3`
  height: 24px;
  font-size: 1em;
  color: #38424D;
  font-weight: 600;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 4px;
  letter-spacing: -0.35px;
  font-family: 'Proxima Nova';
`;

export const ResetPasswordForm = styled.form`
  width: 100%;
  margin-bottom: 10px;
`;

export const SuccessParagraphs = styled.p`
  font-family: 'Proxima Nova';
  text-align: center;
  font-style: normal;
  line-height: 120%;
  font-weight: 400;
  color: #38424D;
  font-size: 1em;
  margin: 8px 0 0;
`;

